import { Card } from "antd";
import { theme } from "antd";
import React from "react";
import Models from "../Models";

import { FiFilm, FiCopy } from "react-icons/fi";
import { FaFilePowerpoint } from "react-icons/fa";
import TagInfo from "./TagInfo";

const { useToken } = theme;

const AcademicPendencies = () => {
  const { token } = useToken();

  const data = [
    {
      icon: <FiFilm size={20} color={token.colorPrimary} />,
      title: "Conteúdo de vídeo:",
      steps: "3/10",
      type: "Concluídas",
      modelTitle: "Módulo: Gestão de Risco",
      description: "M3 | Livro-Apostila do Módulo 6 Filtros do Método LCB",
      info: "00:41",
    },
    {
      icon: <FiCopy size={20} color={token.colorPrimary} />,
      title: "Conteúdo de arquivo:",
      steps: "3/10",
      type: "Concluídas",
      modelTitle: "Módulo: Gestão de Risco",
      description: "M3 | Livro-Apostila do Módulo 6 Filtros do Método LCB",
      info: "pdf",
    },
    {
      icon: <FaFilePowerpoint size={20} color={token.colorPrimary} />,
      title: "Avaliações:",
      steps: "3/10",
      type: "Concluídas",
      modelTitle: "Módulo: Gestão de Risco",
      description: "M3 | Livro-Apostila do Módulo 6 Filtros do Método LCB",
      info: "4 questões",
    },
  ];

  return (
    <section>
      <Card style={{ padding: 16, backgroundColor: "#FFF", marginTop: 20 }}>
        <h2 style={{ fontSize: "font-size: calc(1.5rem + 0.3vw)" }}>
          Pendências acadêmicas
        </h2>
        {data.map((el, i) => {
          return (
            <div style={{ padding: "0 15px" }} key={`${el.title}-${i}`}>
              <Models
                icon={el.icon}
                title={el.title}
                modelTitle={el.modelTitle}
                description={el.description}
                info={el.info}
                steps={el.steps}
                type={el.type}
              />
            </div>
          );
        })}
        <TagInfo />
      </Card>
    </section>
  );
};

export default AcademicPendencies;
